import Lottie from 'lottie-react'
import animationData from '@assets/lottie/loading-animation.json'

interface LoadingAnimationProps {
  width?: number | string
  height?: number | string
  loop?: boolean
  autoplay?: boolean
  className?: string
}

export const LoadingAnimation = ({
  width = 150,
  height = 150,
  loop = true,
  autoplay = true,
  className = '',
}: LoadingAnimationProps) => {
  console.log('animationData', animationData)
  return (
    <Lottie
      animationData={animationData}
      style={{ width, height }}
      loop={loop}
      autoplay={autoplay}
      className={className}
    />
  )
}
